// Gold botanical line-art ornaments inspired by the user's collage reference
export const CornerLeaves = ({ className = "", flip = false }) => (
  <svg
    className={className}
    viewBox="0 0 140 140"
    fill="none"
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    aria-hidden
  >
    <path d="M5 10 Q40 5, 70 30 Q90 48, 110 75" stroke="#C9A86C" strokeWidth="0.8" fill="none" />
    <path d="M30 8 Q35 18, 42 22 Q38 30, 30 28 Q28 18, 30 8 Z" fill="#C9A86C" opacity="0.55" />
    <path d="M55 18 Q62 25, 66 35 Q58 38, 52 32 Q52 25, 55 18 Z" fill="#C9A86C" opacity="0.55" />
    <path d="M82 38 Q92 42, 96 52 Q88 58, 78 52 Q78 44, 82 38 Z" fill="#C9A86C" opacity="0.55" />
    <path d="M104 60 Q116 64, 122 78 Q112 84, 100 76 Q100 66, 104 60 Z" fill="#C9A86C" opacity="0.55" />
    <circle cx="22" cy="36" r="1.4" fill="#C9A86C" />
    <circle cx="48" cy="48" r="1.4" fill="#C9A86C" />
    <circle cx="76" cy="68" r="1.4" fill="#C9A86C" />
  </svg>
);

export const SectionFlourish = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 280 32" fill="none" aria-hidden>
    <line x1="0" y1="16" x2="100" y2="16" stroke="#C9A86C" strokeWidth="0.6" />
    <path d="M108 16 Q113 9, 118 16 Q113 23, 108 16 Z" fill="#C9A86C" opacity="0.7" />
    <circle cx="124" cy="16" r="2.5" fill="none" stroke="#C9A86C" strokeWidth="0.7" />
    <path d="M132 8 Q140 16, 132 24 Q148 16, 132 8 Z" fill="#C9A86C" opacity="0.75" />
    <circle cx="156" cy="16" r="2.5" fill="none" stroke="#C9A86C" strokeWidth="0.7" />
    <path d="M162 16 Q167 9, 172 16 Q167 23, 162 16 Z" fill="#C9A86C" opacity="0.7" />
    <line x1="180" y1="16" x2="280" y2="16" stroke="#C9A86C" strokeWidth="0.6" />
  </svg>
);

export const Sprig = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 80 24" fill="none" aria-hidden>
    <path d="M2 12 Q40 2, 78 12" stroke="#C9A86C" strokeWidth="0.7" />
    <path d="M18 9 Q22 4, 26 8 Q23 13, 18 9 Z" fill="#C9A86C" opacity="0.6" />
    <path d="M34 6 Q38 2, 42 5 Q39 11, 34 6 Z" fill="#C9A86C" opacity="0.6" />
    <path d="M52 6 Q56 2, 60 5 Q57 11, 52 6 Z" fill="#C9A86C" opacity="0.6" />
  </svg>
);

export const HeartDivider = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 200 16" fill="none" aria-hidden>
    <line x1="0" y1="8" x2="86" y2="8" stroke="#C9A86C" strokeWidth="0.6" />
    <path d="M100 4 C97 1, 92 1, 92 5 C92 8, 100 12, 100 12 C100 12, 108 8, 108 5 C108 1, 103 1, 100 4 Z" fill="#C5868A" />
    <line x1="114" y1="8" x2="200" y2="8" stroke="#C9A86C" strokeWidth="0.6" />
  </svg>
);
